// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title.v-subheader[data-v-76aee2be]{padding:0;height:inherit;font-size:1.2em}.span-value[data-v-76aee2be]{padding-left:30px!important;height:inherit;font-size:16px}.tr-padding[data-v-76aee2be]{padding-left:40px!important}", ""]);
// Exports
module.exports = exports;
